export default {
  Calendar: {
    Details: {
      Title: 'Clients',
      Time: 'Time',
      Status: 'Status',
    },
    Styles: {
      ShiftConfirmation: 'Confirmed',
      ClockInConfirmation: 'Clocked In',
      ClockOutConfirmation: 'Clocked Out',
      Unconfirmed: 'Unconfirmed',
      RequestedReschedule: 'Requested Reschedule',
      RequestedCancel: 'Requested Cancellation',
      Cancelled: 'Cancelled',
      Rescheduled: 'Rescheduled',
    },
    Filter: {
      User: {
        ScheduleForThisWeek: 'Have schedule for this week',
      },
      Event: {
        NotConfirmedShift: 'Has not confirmed shift',
        NotClockedIn: 'Has not clocked in',
        NotClockedOut: 'Has not clocked out',
        LateClockin: 'Has clocked in late',
        EarlyClockout: 'Has clocked out early',
      },
    },
  },
};
